<ion-content class="profile-error-content">
  <div class="profile-error-card">
    <ion-icon
      name="alert-circle-outline"
      class="profile-error-icon"
      aria-hidden="true"
    ></ion-icon>

    <h2 class="profile-error-title">Impossibile caricare il profilo</h2>

    <p class="profile-error-message">
      Controlla la tua connessione e riprova per continuare.
    </p>

    @if (retryFailed) {
      <p class="profile-error-inline" role="alert">
        Riprova non riuscita. Verifica la connessione.
      </p>
    }

    <ion-button
      expand="block"
      color="primary"
      class="profile-error-button"
      [disabled]="retrying"
      (click)="retry()"
    >
      @if (retrying) {
        <ion-spinner name="crescent" slot="start"></ion-spinner>
        <span>Riprovo...</span>
      } @else {
        <ion-icon name="refresh-outline" slot="start" aria-hidden="true"></ion-icon>
        <span>Riprova</span>
      }
    </ion-button>
  </div>
</ion-content>
